// TSM Group CLE brand lockup — four ascending squares (Midnight Navy, Deep Teal,
// Amber, Warm White) representing TSM4: growth, stronger systems, risk awareness,
// and forward movement.
export const LogoMark = ({ className = "h-10 w-11", light = false }) => (
  <svg viewBox="0 0 59 52" fill="none" className={className} aria-hidden="true">
    <rect x="2" y="42" width="10" height="10" rx="2.5" fill={light ? "#F7F8F5" : "#172B3A"} />
    <rect x="13" y="30" width="12" height="12" rx="2.5" fill="#147D80" />
    <rect x="26" y="16" width="14" height="14" rx="2.5" fill="#E5AD46" />
    <rect x="41" y="0" width="16" height="16" rx="2.5" fill="#F7F8F5" stroke="#172B3A" strokeOpacity={light ? 0 : 0.14} strokeWidth="1" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-10 w-11 shrink-0" light={light} />
    <span className="flex flex-col leading-none">
      <span
        className={`text-[22px] font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}
      >
        TSM <span className={`text-sm font-bold tracking-[0.14em] ${light ? "text-white/80" : "text-teal"}`}>GROUP CLE</span>
      </span>
      <span
        className={`mt-1.5 font-mono text-[9px] uppercase tracking-[0.28em] ${light ? "text-gold" : "text-tealdeep"}`}
      >
        Think Safe Mitigation
      </span>
    </span>
  </span>
);
